module.exports = __webpack_public_path__ + "img/52002755_L.a8d3999a.png";